import { useTranslation } from '@amusnet/translations/react'
import playNowButtonOuterLayer from '@assets/intro-screen/play-button-outer-layer.svg'
import playNowButtonInnerBottomLayer from '@assets/intro-screen/play-button-inner-bottom-layer.svg'
import playNowButtonInnerTopLayer from '@assets/intro-screen/play-button-inner-top-layer.svg'
import playNowButtonHover from '@assets/intro-screen/play-button-hover.svg'

import React, { MouseEvent, useState } from 'react'
import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { useConfigurationStore } from '@stores/index'
import { ViewportType } from 'game-ui-types'

type PlayButtonProps = {
    onClick: (event: MouseEvent) => void
    buttonStyle: BuildGradientStyle
    backgroundStyle: BuildGradientStyle
    className: string
}

export const PlayButton: React.FC<PlayButtonProps> = (props) => {
    const viewport = useConfigurationStore((s) => s.viewport)

    const [isMouseOverButton, setIsMouseOverButton] = useState(false)
    const { t } = useTranslation()

    const { className, onClick, buttonStyle, backgroundStyle } = props

    return (
        <button
            onClick={onClick}
            className={className}
            onMouseEnter={() => setIsMouseOverButton(true)}
            onMouseLeave={() => setIsMouseOverButton(false)}
        >
            <div>
                <img className="mx-auto" src={playNowButtonOuterLayer} />
                <div
                    className="absolute left-[4px] top-[4px] h-[80px] w-[270px] rounded-[10px]"
                    style={backgroundStyle}
                ></div>
                <div
                    className="absolute left-[8px] top-[8px] h-[72px] w-[262px] rounded-[8px]"
                    style={buttonStyle}
                ></div>
                <img className="absolute left-[8px] top-[8px]" src={playNowButtonInnerBottomLayer} />
                <img className="absolute left-[8px] top-[8px]" src={playNowButtonInnerTopLayer} />
                <div className="absolute top-[50%] w-[80%] left-[50%] text-white font-bold text-3xl drop-shadow-[0_4px_1px_rgba(0,0,0,0.45)] transform -translate-x-1/2 -translate-y-1/2 text-[30px]">
                    {t(`gameui.intro.playNow`)}
                </div>
                {isMouseOverButton && viewport === ViewportType.DESKTOP && (
                    <img className="absolute left-[8px] top-[8px]" src={playNowButtonHover} />
                )}
            </div>
        </button>
    )
}
